import { CdnService } from '@/common/services/cdn/cdn.service';
import { PopularDestinations } from '@/core/domain/popular-destinations/models/popular-destinations.model';
import { GetPopularDestinationsUseCase } from '@/core/domain/popular-destinations/usecases/getPopularDestinations.usecase';
import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'fe-popular-destinations',
    templateUrl: './popular-destinations.component.html',
    styleUrls: ['./popular-destinations.component.scss'],
})
export class PopularDestinationsComponent implements OnInit {
    popularDestinations?: PopularDestinations;
    placeholders = new Array(3);

    constructor(
        private readonly getPopularDestinationsUseCase: GetPopularDestinationsUseCase,
    ) {}

    ngOnInit(): void {
        this.getPopularDestinations();
    }

    onImageError(event: Event) {
        const target = event.target as HTMLImageElement;
        target.src = CdnService.url('images/nopic.webp');
    }

    public getPopularDestinations(): void {
        this.getPopularDestinationsUseCase
            .execute()
            .subscribe((popularDestinations) => {
                this.popularDestinations = popularDestinations;
            });
    }
}
